import { utils, write } from 'xlsx';

const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);

  for (let i = 0; i < s.length; i += 1) {
    view[i] = s.charCodeAt(i);
  }

  return buf;
};
/**
 *
 * @param {Array} headers -
 * @param {string} fileName -
 */
export const createTemplateExcel = (headers, fileName) => {
  // Create a new workbook
  const workbook = utils.book_new();

  // Create a new worksheet
  const worksheet = utils.aoa_to_sheet([headers]);

  // Add the worksheet to the workbook
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  // Write the workbook to binary Excel data
  const excelData = write(workbook, { bookType: 'xlsx', type: 'binary' });

  // Convert the binary Excel data to a Blob
  const blob = new Blob([s2ab(excelData)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  // Create a download link
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = `${fileName}.xlsx`;

  // Append the download link to the document body and click it programmatically
  document.body.appendChild(downloadLink);
  downloadLink.click();

  // Cleanup
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(downloadLink.href);
};

/**
 * Create a template Excel file with multiple sheets
 * @param {Array} sheets - The sheets to be created.
 * @param {string} fileName - The name of the file to be downloaded.
 */
export const createTemplateExcelWithMultipleSheets = (sheets, fileName) => {
  // Create a new workbook
  const workbook = utils.book_new();

  sheets?.forEach((sheet) => {
    // Create a new worksheet
    const worksheet = utils.aoa_to_sheet([sheet.data]);

    // Add the worksheet to the workbook
    utils.book_append_sheet(workbook, worksheet, sheet.name);
  });

  // Write the workbook to binary Excel data
  const excelData = write(workbook, { bookType: 'xlsx', type: 'binary' });

  // Convert the binary Excel data to a Blob
  const blob = new Blob([s2ab(excelData)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  // Create a download link
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = `${fileName}.xlsx`;

  // Append the download link to the document body and click it programmatically
  document.body.appendChild(downloadLink);
  downloadLink.click();

  // Cleanup
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(downloadLink.href);
};

/**
 * Create a template Excel file with data
 * @param {string} fileName - The name of the file to be downloaded
 * @param {Array} data - The data to be written to the Excel file
 */
export const createTemplateExcelWithData = (fileName, data) => {
  const workbook = utils.book_new();
  const worksheet = utils.json_to_sheet(data);
  utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const excelData = write(workbook, { bookType: 'xlsx', type: 'binary' });
  const blob = new Blob([s2ab(excelData)], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const downloadLink = document.createElement('a');
  downloadLink.href = URL.createObjectURL(blob);
  downloadLink.download = `${fileName}.xlsx`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(downloadLink.href);
};

export default {
  createTemplateExcel,
};
